import React, { FC, useEffect, useState } from 'react' // useCallback
import { useHits, useMenu } from 'react-instantsearch-core'
//import { Finish } from '../components/finish'
import type { ProductHit } from '../components/product'
import { Product } from '../components/product'
import { SizeGuide } from '../components/size-guide'
import { refreshYotpoWidget } from '../plugins/yotpo'

export type Props = {
  hits_per_page: number
}

export const App: FC<Props> = ({ hits_per_page }) => {
  const { hits } = useHits<ProductHit>()

  const [isInitRun, setIsInitRun] = useState<boolean>(true)

  const { refine } = useMenu({ attribute: 'named_tags.is_parent' })

  // Filters
  //const filtersDataItem = document.getElementById('algolia-finish-filters-json')
  //const filters =
  //  filtersDataItem !== null ? JSON.parse(filtersDataItem?.innerText) : ''

  useEffect(() => {
    if (isInitRun === true) {
      refine('yes')
      setIsInitRun(false)
    }
  }, [refine, isInitRun, setIsInitRun])

  useEffect(() => {
    refreshYotpoWidget()
  })

  /*const setIsParent = useCallback(
    function (val: boolean) {
      val === true ? refine('yes') : refine('no')
    },
    [refine]
  )*/

  return (
    <div>
      {/* Filter bar */}

      {/* REQUESTED BY CLIENT TO HIDE FILTERS FOR NOW */}

      {/*<div className="Algolia-nav">
        <div className="Algolia-navBody--wood">
          <div className="Algolia-colorsGrid">
            <Finish
              attribute="named_tags.finish"
              title={filters.finish.title}
              items={filters.finish.filters}
              setIsParent={setIsParent}
            />
          </div>
        </div>
      </div>*/}

      {/* Body */}
      <div>
        <div className="Algolia-body--collection">
          {hits?.map((item, i) => (
            <Product key={i} hit={item} />
          ))}
        </div>

        <div className="Algolia-sizeGuideContainer">
          <SizeGuide />
        </div>

      </div>
    </div>
  )
}
